import dayjs from 'dayjs';
import * as React from 'react';
import { IRange, ISelectOption } from '../../../../data/types';
import { formatDay } from '../../../../utils/date';
import { Row } from '../../../layout/Row';
import { ControlLabel } from '../ControlLabel';
import { ControlSpacer } from '../ControlSpacer';
import { DateInput } from '../DateInput';

interface IProps {
  comparison?: boolean;
  disabled?: boolean;
  dateRange: IRange;
  onChange: (range: unknown) => void;
  mode?: 'LOCAL' | 'UTC';
}

/**
 * @description converts a js timestamp to a selectable option
 * @param timestamp
 * @returns
 */
const timestampToDateOption = (timestamp: number): ISelectOption<number> => ({
  value: timestamp,
  label: formatDay(timestamp),
});

export const TimeframeSelect = (props: IProps): React.ReactElement => {
  /**
   * @description handle start date change
   * @param dates
   */
  const startDateChangeHandler = (dates: Date[]): void => {
    const date =
      props.mode === 'LOCAL'
        ? new Date(
            dates[0].getFullYear(),
            dates[0].getMonth(),
            dates[0].getDate()
          ).toISOString()
        : Date.UTC(
            dates[0].getFullYear(),
            dates[0].getMonth(),
            dates[0].getDate()
          );

    const fromTimestamp =
      props.mode === 'LOCAL'
        ? dayjs(date).startOf('day').valueOf()
        : dayjs.utc(date).startOf('day').valueOf();

    const newRange = {
      to: props.dateRange?.to,
      from: timestampToDateOption(fromTimestamp),
    };
    props.onChange(newRange);
  };
  /**
   * @description handle end date change
   * @param dates
   */
  const endDateChangeHandler = (dates: Date[]): void => {
    const date =
      props.mode === 'LOCAL'
        ? new Date(
            dates[0].getFullYear(),
            dates[0].getMonth(),
            dates[0].getDate()
          ).toISOString()
        : Date.UTC(
            dates[0].getFullYear(),
            dates[0].getMonth(),
            dates[0].getDate()
          );

    const toTimestamp =
      props.mode === 'LOCAL'
        ? dayjs(date).endOf('day').valueOf()
        : dayjs.utc(date).endOf('day').valueOf();
    const newRange = {
      from: props.dateRange?.from,
      to: timestampToDateOption(toTimestamp),
    };
    props.onChange(newRange);
  };

  return (
    <Row>
      <ControlSpacer style={{ flex: 1 }}>
        <ControlLabel>Start Date</ControlLabel>
        <DateInput
          value={props.dateRange?.from?.value ?? ''}
          disabled={props.disabled}
          onChange={startDateChangeHandler}
          maxDate={formatDay(props?.dateRange?.to?.value)}
          local={props.mode === 'LOCAL'}
        />
      </ControlSpacer>
      {!props.comparison && (
        <ControlSpacer style={{ flex: 1, marginLeft: '5px' }}>
          <ControlLabel>End Date</ControlLabel>
          <DateInput
            value={props.dateRange?.to?.value ?? ''}
            disabled={props.disabled}
            onChange={endDateChangeHandler}
            minDate={formatDay(props?.dateRange?.from?.value)}
            local={props.mode === 'LOCAL'}
          />
        </ControlSpacer>
      )}
    </Row>
  );
};
